import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['older', 'toggle']

  toggle(event) {
    event.preventDefault()
    const expanded = this.olderTarget.getAttribute('aria-expanded') === 'true'
    this.olderTarget.setAttribute('aria-expanded', String(!expanded))
    this.olderTarget.style.display = expanded ? 'none' : ''
    this.toggleTarget.textContent = expanded ? 'すべて表示 →' : '直近のみ表示 ↑'
  }
}
